export const ALEXA = "alexa";

// Possible request errors
export const ErrorCodes: { [key: string]: string } = {
  INVALID_EMAIL: "invalid_email",
  SERVER_INTERNAL_ERROR: "server_internal_error",
  INTEGRITY_ERROR: "integrity_error",
  TOKEN_NOT_FOUND: "token_not_found",
  TOKEN_INVALID: "token_invalid",
  TOKEN_EXPIRED: "token_expired",
  BAD_REQUEST: "bad_request",
  INITIALIZING: "initializing",
  UNAUTHORIZED: "unauthorized",
  NOT_FOUND: "not_found",
};

export const RedirectErrors: { [key: string]: string } = {
  TOKEN_NOT_FOUND: "token_not_found",
  TOKEN_INVALID: "token_invalid",
  TOKEN_EXPIRED: "token_expired",
  UNAUTHORIZED: "unauthorized",
  NOT_FOUND: "not_found",
};

export const StorageKeys = {
  USER: "user",
  PARENT_CLIENT_ID: "parent_client_id",
  APP_LOG: "app_log",
  ENV: "environment",
  USER_ID: "user_id",
  VERSION: "version",
  SUBSCRIPTION_DATA: "subscription_data",
  SELECTED_SUBSCRIPTION: "selected_plan",
};

export const supportEmail = "support@stackcare.com";
export const termsOfService = "https://stack.care/terms-of-service";
export const privacyPolicy = "https://stack.care/privacy-policy";
export const stripeURL = "https://stripe.com";
